<p-drawer [(visible)]="app.MessageSideNavVisible" position="right" [style]="{'background': '#10101070', 'backdrop-filter': 'blur(15px)', 'border': '0'}" [modal]="false">
    <ng-template #header>
        <div class="w-full">
            <h4 style="color: white">Messages</h4>
            <div class="flex items-center">
            <p-checkbox inputId="mark" [ngModel]="messageStateService.markAsRead" [binary]="true"
                (onChange)="onMarkAsRead($event.checked, this.app.userInfo.EmployeeListID)"></p-checkbox>
            <label for="mark" class="ml-2 text-white">Mark as read</label>
        </div>
        </div>
    </ng-template>
    <div class="grid mt-2">
        <div class="col-12">
            <div *ngIf="adminMsg != null">
                <div class="ef-message" [innerHTML]="adminMsg | safe: 'html'"></div>
            </div>
        </div>
        <div class="col-12">
            <div *ngIf="mgrMsg != null">
                <div class="ef-message" [innerHTML]="mgrMsg | safe: 'html'"></div>
            </div>
        </div>
        <div class="col-12">
            <div *ngIf="userMsg != null">
                <div class="ef-message" [innerHTML]="userMsg | safe: 'html'"></div>
            </div>
        </div>
    </div>
</p-drawer>
